import { Component, OnInit } from '@angular/core';
import { ServerTokenService } from '../../services/server-token.service';
import { FacilitySettings, FacilitySettingsExtended } from '../facilities-settings/facilities-settings.interface';

@Component({
  selector: 'ngx-facility-config',
  templateUrl: './facility-config.component.html',
  styleUrls: ['./facility-config.component.scss']
})
export class FacilityConfigComponent implements OnInit {

  facilitySettings: FacilitySettings[] = [];
  constructor(private server: ServerTokenService) { }
  ngOnInit(): void {
    // TODO: get facility config
    this.initFacilityData()
  }

  async initFacilityData() {
    const data = await this.server.getWithToken<FacilitySettings[]>('snfs/admin/getFacilitySettings').toPromise();
    console.log(data);
    this.facilitySettings = data;
  }

  async updateFacilityConfig(facility, field, value) {
    try {
      const res = await this.server.postWithToken('snfs/admin/updateFacilitySettingsFields', { _id: facility._id, updateFields: {['' + field]: value} }).toPromise();
      console.log(res);
    } catch (error) {
      console.log(error);
    }
  }
    
}
